export default {
  methods: {
    calculateOridinalNumber(number) {
      if(this.$i18n.locale === "en") {
        const suffixes = ['th', 'st', 'nd', 'rd'];
        const value = Math.abs(number) % 100;
        const suffix = (value > 10 && value < 20) ? 'th' : suffixes[(value % 10) < 4 ? value % 10 : 0];
        
        return `${number}<sup>${suffix}</sup>`;
      }
      else
        return number;
    },
  }
};
